import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0)",
		children: [
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("line", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				x1: .5,
				y1: 8,
				x2: 11,
				y2: 8
			}) }) }),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M8.5,10.5L11,8L8.5,5.5"
			}),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M2.2,11.1c1.7,3.5,5.9,4.9,9.4,3.2s4.9-5.9,3.2-9.4S8.9,0,5.4,1.7C4.1,2.4,3,3.4,2.3,4.7"
			}) }) })
		]
	})
});
export { SvgIconLogout as ReactComponent };
